import { Component } from 'angular-ts-decorators';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { Session } from '@shared/app/scripts/services/session';

/**
 * Renders the top bar/nav bar. Should be run
 * in index.html for the purpose of confirming email addresses
 */
@Component({
  selector: 'swConfirmEmail',
  template: require('./sw-confirm-email.html').default,
})
export class SwConfirmEmailComponent {
  faEnvelope = faEnvelope;
  emailVerificationPending: boolean;
  isEmailConfirmationShown: boolean;
  email: any;

  constructor(
    private $location: ng.ILocationService,
    private session: Session,
    private user,
  ) {
    'ngInject';

    this.emailVerificationPending = false;

    this.session.current$.subscribe((currentSession) => {
      this.email = currentSession.email;
      this.emailVerificationPending =
        currentSession.email_verify_pending &&
        $location.path() !== '/email-verification';
    });
  }

  resendEmailConfirmation(email) {
    const promise = this.user.resendEmailVerificationKey(email);
    promise.then(this.hideVerficationMessage);
    return promise;
  }

  hideVerficationMessage = () => {
    this.emailVerificationPending = false;
    this.isEmailConfirmationShown = false;
  };
}
